import { TextField } from "@material-ui/core";
import { DiscountErrorFragment } from "@saleor/fragments/types/DiscountErrorFragment";
import { getFormErrors } from "@saleor/utils/errors";
import getDiscountErrorMessage from "@saleor/utils/errors/discounts";
import React, { FC } from "react";
import { useIntl } from "react-intl";

import { useCommonFieldStyles } from "../../styles";
import RadioButton from "../RadioButton/RadioButton";
import { INPUT_PROPS } from "./constants";

interface ILimitNumOfTimesRButtonProps {
  radioButtonValue: boolean;
  onRadioButtonValueChange: (val: boolean) => void;
  errors: DiscountErrorFragment[];
  clientErrors?: {
    usageLimit?: string;
  };
  isDisabled: boolean;
  usageLimitValue: string;
  onUsageLimitValueChange: (val: string) => void;
}

const LimitNumOfTimesRButton: FC<ILimitNumOfTimesRButtonProps> = ({
  radioButtonValue,
  isDisabled,
  onRadioButtonValueChange,
  errors,
  clientErrors,
  usageLimitValue,
  onUsageLimitValueChange
}) => {
  const intl = useIntl();
  const classes = useCommonFieldStyles(undefined);
  const formErrors = getFormErrors(["usageLimit"], errors);

  const handleUsageLimitValueChange = event => {
    onUsageLimitValueChange(event.target.value);
  };

  return (
    <div className={classes.divContainerStyle}>
      <RadioButton
        label={intl.formatMessage({
          defaultMessage:
            "Limit number of times this discount can be used in total"
        })}
        value={radioButtonValue}
        onChange={onRadioButtonValueChange}
        isDisabled={isDisabled}
      />
      {radioButtonValue && (
        <TextField
          id="limitOfUsesTxt"
          disabled={isDisabled}
          error={!!formErrors.usageLimit || !!clientErrors.usageLimit}
          helperText={
            getDiscountErrorMessage(formErrors.usageLimit, intl) ||
            clientErrors.usageLimit
          }
          label={intl.formatMessage({
            defaultMessage: "Limit of Uses",
            description: "voucher"
          })}
          name="usageLimit"
          value={usageLimitValue}
          onChange={handleUsageLimitValueChange}
          inputProps={INPUT_PROPS}
          fullWidth
        />
      )}
    </div>
  );
};

export default LimitNumOfTimesRButton;
